import * as React from "react"
import * as AvatarPrimitive from "@radix-ui/react-avatar"

import { cn } from "@/lib/utils"

const Avatar = React.forwardRef(({ className, ...props }, ref) => (
  <AvatarPrimitive.Root
    ref={ref}
    className={cn("relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full", className)}
    {...props} />
))
Avatar.displayName = AvatarPrimitive.Root.displayName

const AvatarImage = React.forwardRef(({ className, ...props }, ref) => (
  <AvatarPrimitive.Image
    ref={ref}
    // `object-cover` is critical here — without it Radix's
    // `aspect-square h-full w-full` would non-uniformly scale
    // landscape/portrait uploads, which is what made every Messenger /
    // Network / drawer avatar look pixelated and blurry after the
    // backend resolver fix. `object-cover` keeps the original aspect
    // ratio and crops to fill the circle, so the photo stays sharp at
    // every size we render it at (28px row → 96px drawer).
    className={cn("aspect-square h-full w-full object-cover object-center", className)}
    // Hint the browser to keep the bitmap sharp when down/up-scaling.
    // `loading="eager"` ensures the inbox first-paint shows real photos
    // immediately instead of flashing fallbacks; Radix renders this
    // <img> only AFTER the URL resolves so there's no wasted request.
    loading="eager"
    decoding="async"
    {...props} />
))
AvatarImage.displayName = AvatarPrimitive.Image.displayName

const AvatarFallback = React.forwardRef(({ className, ...props }, ref) => (
  <AvatarPrimitive.Fallback
    ref={ref}
    className={cn(
      "flex h-full w-full items-center justify-center rounded-full bg-muted",
      className
    )}
    {...props} />
))
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName

export { Avatar, AvatarImage, AvatarFallback }
